import { Box, Flex } from '@theme-ui/components';
import { useTheme } from '@emotion/react';

import CheckIcon from '@app/assets/icons/CheckIcon';
import { CheckIconWrapper, Title } from '@app/components/Card/Card';
import FormattedMoney from '@app/components/FormattedMoney';
import { GiftCardStyled } from '@app/pages/Pricing/components/GiftProductLayout/styles';
import { CurrentPrice } from '@app/pages/Pricing/components/Price/styles';

import type { GiftCardProps } from './GiftCard.constants';

export const GiftCard = ({
  isSelected = false,
  giftCardItem,
  currency,
  setSelectedGiftCard,
  ...props
}: GiftCardProps) => {
  const theme = useTheme();
  const price = {
    currency: currency,
    ...giftCardItem,
  };

  return (
    <GiftCardStyled
      data-testid={'gift-card'}
      highlight={isSelected}
      {...props}
      onClick={() => setSelectedGiftCard(giftCardItem)}
    >
      <Box
        sx={{
          justifyContent: 'space-between',
          minWidth: '80%',
        }}
      >
        {isSelected && (
          <CheckIconWrapper>
            <CheckIcon
              data-testid="gift-card-check-icon"
              fill={theme.colors.lightBlue}
            />
          </CheckIconWrapper>
        )}

        <Flex
          sx={{
            flexDirection: 'column',
            justifyContent: 'space-between',
          }}
        >
          <Title>Gift Card</Title>
          <Flex
            sx={{
              flexDirection: 'column',
              justifyContent: 'space-between',
            }}
          >
            {price && (
              <CurrentPrice>
                <FormattedMoney {...price} />
              </CurrentPrice>
            )}
          </Flex>
        </Flex>
      </Box>
    </GiftCardStyled>
  );
};
